import { Grid2 } from "@mui/material";
import React, { useState } from "react";
import styles from "./NewPlanSignupLayout.module.scss";
import { NavBar } from "../Admin/AdminComponents/Navbar";

function NewPlanSignupLayout({ component: PageComponent, ...rest }) {
  const [search, setSearch] = useState(false);
  const [value, setValue] = useState("");
  return (
    <>
      <Grid2 className={styles.containerBackground}>
        <Grid2 className={styles.Background}>
          <NavBar
            search={search}
            setSearch={setSearch}
            value={value}
            setValue={setValue}
            showNotifications={false}
            showProfile={false}
            showLogout={false}
          />
          <PageComponent />
        </Grid2>
      </Grid2>
    </>
  );
}

export default NewPlanSignupLayout;
